import React from "react";
import { useTranslation } from "react-i18next";
import { PaymentField } from "./PaymentField";
import { YavinConfig } from "./types";

type YavinFormProps = {
    config: YavinConfig;
    onChange: (update: Partial<YavinConfig>) => void;
};

export function YavinForm({ config, onChange }: YavinFormProps) {
    const { t } = useTranslation();
    return (
        <div data-testid="yavin-form" className="payment-form__clz">
            <PaymentField
                testId="yavin-id"
                label={t("ID")}
                value={config.ID}
                onChange={(ID) => onChange({ ID })}
            />
            <PaymentField
                testId="yavin-api-key"
                label={t("API key")}
                value={config.CleAPI}
                onChange={(CleAPI) => onChange({ CleAPI })}
            />
            <PaymentField
                testId="yavin-public-account-id"
                label={t("Public Account ID")}
                value={config.PublicAccountID}
                onChange={(PublicAccountID) => onChange({ PublicAccountID })}
            />
        </div>
    );
}
